import React from 'react';
import { ActivityIndicator, View, Platform } from 'react-native';
import { FileType } from '@annunciate/core';
import { Reader } from '@annunciate/ui/dist/components/player/Reader';
import { VideoPlayer } from '@annunciate/ui/dist/components/player/VideoPlayer';
import { MiniPlayer } from './MiniPlayer';
import { FullPlayer } from './FullPlayer';
export const Player = ({ position, playing, onTogglePlayer, }) => {
    if (!playing) {
        return (React.createElement(View, { style: { marginTop: 20 } },
            React.createElement(ActivityIndicator, null)));
    }
    const image = playing.cover?.src;
    const name = playing.name;
    const type = playing.asset?.type;
    const height = (Platform.OS === 'web' ? '100vh' : '100%');
    if (type === FileType.AUDIO) {
        return (React.createElement(View, { style: { height } },
            React.createElement(MiniPlayer, { position: position, image: image, name: name, onTogglePlayer: onTogglePlayer }),
            React.createElement(FullPlayer, { position: position, playing: playing, onTogglePlayer: onTogglePlayer })));
    }
    else if (type === FileType.EBOOK) {
        return (React.createElement(View, { style: { height } },
            React.createElement(MiniPlayer, { position: position, image: image, name: name, onTogglePlayer: onTogglePlayer, isPlayButtonEnabled: false }),
            React.createElement(Reader, { position: position, onTogglePlayer: onTogglePlayer, playing: playing })));
    }
    else if (type === FileType.VIDEO) {
        return (React.createElement(VideoPlayer, { playing: playing, position: position, name: name, onTogglePlayer: onTogglePlayer }));
    }
    else {
        return null;
    }
};
//# sourceMappingURL=Player.js.map